// --- Our Modules --------------------------------------------------------------------------------
import Skeleton from "@/UI/atoms/Skeleton";

// --- Constants ----------------------------------------------------------------------------------

/** Enough tiles and cards to hold the page's real height, so nothing jumps when the data lands. */
const TILES = [0, 1, 2, 3, 4, 5];
const CARDS = [0, 1, 2];

// --- Logic --------------------------------------------------------------------------------------

export default function Loader() {
    return (
        <div className="home-loading" aria-busy="true">
            <div className="home-tiles">
                {TILES.map((key) => (
                    <Skeleton key={key} className="home-skeleton-tile" />
                ))}
            </div>

            <Skeleton className="home-skeleton-wide" />

            <div className="home-cards home-cards--triple">
                {CARDS.map((key) => (
                    <Skeleton key={key} className="home-skeleton-card" />
                ))}
            </div>
        </div>
    );
}
